import { createFileRoute } from '@tanstack/react-router'

import NewCriteriaContent from '../../../-components/criteria/new'

export const Route = createFileRoute(
  '/_authenticated/$alias/settings/scorecards/$scorecardId/criteria/new/$sectionId',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { scorecardId, sectionId } = Route.useParams()
  return <NewCriteriaContent scorecardId={scorecardId} sectionId={sectionId} />
}
